// Using a JS file here so i can pull this data into gatsby-node
module.exports = {
  title: 'Cameron Woodmansee',
  description: 'Get on My Level',
  url: 'https://camdub.io',
};



// WEBPACK FOOTER //
// ./src/config.js